import { TextVariant } from './types';

export const END_CONSTANTS: Record<string, TextVariant> = {
  earlyEnd: {
    common: '많은 참여로 인한 참가권 소진으로',
  },
  endText: {
    common: <>새틀라이트가 종료되었습니다.</>,
  },
  endEarlyText: {
    common: (
      <>
        새틀라이트가
        <br /> 조기 종료되었습니다.
      </>
    ),
  },
  endSubText: {
    common: (
      <>
        참가권을 획득하신분들은
        <br />
        <span>오프라인 이벤트 탭으로 이동</span>하여
        <br />
        토너먼트정보를 확인해주세요!
      </>
    ),
  },
  endDesc: {
    common: '추후에 열릴 토너먼트도\n많은 기대 부탁드립니다.',
  },
  btnText: { common: '오프라인 이벤트 참가 안내 확인 하기' },
};
